
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/other-tools",
      function () {
        return require("private-next-pages/other-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/other-tools"])
      });
    }
  